/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserLastIntakeSheetResource { 
    date: string;
    /**
     * ISO 8601 datum vytvoření (poslední NL)
     */
    status: string | null;
}

